import { useState, useEffect } from 'react';
import { useStore } from '../../data/store';

export default function CookieBanner() {
  const settings = useStore((s) => s.settings);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem('rnr_cookies');
    if (!choice) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('rnr_cookies', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('rnr_cookies', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-[#1c1c1c] border-t-2 border-accent-red" style={{ padding: '12px 20px' }}>
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-body text-text-muted text-sm text-center sm:text-left">
          {settings?.cookieText}
        </p>
        <div className="flex gap-2 w-full sm:w-auto shrink-0">
          <button onClick={accept} className="flex-1 sm:flex-initial bg-accent-red text-white font-heading text-sm tracking-wider px-6 py-3 border-2 border-accent-red hover:bg-transparent hover:text-accent-red transition-all min-h-[44px]">
            Akzeptieren
          </button>
          <button onClick={reject} className="flex-1 sm:flex-initial border-2 border-divider text-text-muted font-heading text-sm tracking-wider px-6 py-3 hover:border-text-primary hover:text-text-primary transition-all min-h-[44px]">
            Ablehnen
          </button>
        </div>
      </div>
    </div>
  );
}
